import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SpacingModule } from '@frk/eds-components';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { InteractiveContentEntryComponent } from './interactive-content-entry/interactive-content-entry.component';

@NgModule({
  declarations: [InteractiveContentEntryComponent],
  imports: [CommonModule, SpacingModule],
})
export class InteractiveContentModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Interactive Content': InteractiveContentEntryComponent,
    };
  }
}
